import { useMemo } from 'react';
import { type CurrentUser } from 'Users';
import { getProgramSwitcherConfigs, type ProgramSwitcherProgramConfig } from 'ProgramSwitcher';

export function useProgramSwitcherConfigs(currentUser: CurrentUser | null): ProgramSwitcherProgramConfig[] {
    // Extract prefUserProgramFieldStateId as a separate dependency so React detects
    // when the user's preferred program changes (object reference stays the same)
    const prefUserProgramFieldStateId = currentUser?.prefUserProgramFieldStateId ?? null;

    const programConfigs = useMemo(() => {
        if (!currentUser) {
            return [];
        }

        return getProgramSwitcherConfigs(currentUser);
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- prefUserProgramFieldStateId triggers recompute when user's preferred program changes
    }, [currentUser, prefUserProgramFieldStateId]);

    return programConfigs;
}
